export const EXPLORE_COURSES_SCROLL_SESSION_KEY = "motion.exploreCoursesScroll";
export const EXPLORE_BOOKS_SCROLL_SESSION_KEY = "motion.exploreBooksScroll";

export const EXPLORE_BOOKS_PATH = "/dashboard/courses/books";

export const getExploreCourseAnchorId = (packageId, section = "main") =>
  packageId != null ? `explore-course-${section}-${packageId}` : null;

export const getExploreBookAnchorId = (bookId) =>
  bookId != null ? `explore-book-${bookId}` : null;

export const getExploreHandbookListAnchorId = (bookId) =>
  bookId != null ? `explore-handbook-list-${bookId}` : null;

export const getDashboardContentElement = () =>
  document.querySelector(".dashboard-content");

export const getDashboardContentScrollTop = () =>
  getDashboardContentElement()?.scrollTop ?? 0;

export const saveDashboardScrollState = (sessionKey, state) => {
  try {
    sessionStorage.setItem(
      sessionKey,
      JSON.stringify({
        scrollTop: getDashboardContentScrollTop(),
        ...state,
      })
    );
  } catch {
    // ignore storage failures
  }
};

export const readDashboardScrollState = (sessionKey) => {
  try {
    const raw = sessionStorage.getItem(sessionKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
};

export const clearDashboardScrollState = (sessionKey) => {
  try {
    sessionStorage.removeItem(sessionKey);
  } catch {
    // ignore storage failures
  }
};

export const saveExploreCoursesScrollState = ({
  anchorId = null,
  activeCategoryKey = null,
} = {}) => {
  saveDashboardScrollState(EXPLORE_COURSES_SCROLL_SESSION_KEY, {
    anchorId,
    activeCategoryKey,
  });
};

export const readExploreCoursesScrollState = () =>
  readDashboardScrollState(EXPLORE_COURSES_SCROLL_SESSION_KEY);

export const clearExploreCoursesScrollState = () =>
  clearDashboardScrollState(EXPLORE_COURSES_SCROLL_SESSION_KEY);

export const NEW_STORE_SELECTION_SESSION_KEY = "motion.newStoreSelection";

export const saveNewStoreSelection = ({ sectionIds, duration } = {}) => {
  try {
    sessionStorage.setItem(
      NEW_STORE_SELECTION_SESSION_KEY,
      JSON.stringify({ sectionIds, duration })
    );
  } catch {
    // ignore storage failures
  }
};

export const readNewStoreSelection = () => {
  const saved = readDashboardScrollState(NEW_STORE_SELECTION_SESSION_KEY);
  if (!saved) return null;
  const sectionIds = Array.isArray(saved.sectionIds)
    ? saved.sectionIds.map(Number).filter(Boolean)
    : [];
  return {
    sectionIds,
    duration: Number(saved.duration) || null,
  };
};

export const clearNewStoreSelection = () =>
  clearDashboardScrollState(NEW_STORE_SELECTION_SESSION_KEY);

export const saveExploreBooksScrollState = ({
  anchorId = null,
  activeFilterId = null,
} = {}) => {
  saveDashboardScrollState(EXPLORE_BOOKS_SCROLL_SESSION_KEY, {
    anchorId,
    activeFilterId,
  });
};

export const readExploreBooksScrollState = () =>
  readDashboardScrollState(EXPLORE_BOOKS_SCROLL_SESSION_KEY);

export const clearExploreBooksScrollState = () =>
  clearDashboardScrollState(EXPLORE_BOOKS_SCROLL_SESSION_KEY);

export const restoreDashboardContentScroll = ({ anchorId, scrollTop } = {}) => {
  const container = getDashboardContentElement();
  if (!container) return false;

  const scrollOffset = 24;

  if (anchorId) {
    const element = document.getElementById(anchorId);
    if (element) {
      const containerRect = container.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      const top =
        elementRect.top - containerRect.top + container.scrollTop - scrollOffset;
      container.scrollTo({ top: Math.max(0, top), behavior: "auto" });
      return true;
    }
  }

  if (typeof scrollTop === "number" && scrollTop >= 0) {
    container.scrollTo({ top: scrollTop, behavior: "auto" });
    return true;
  }

  return false;
};

/** @deprecated Use restoreDashboardContentScroll */
export const restoreExploreCoursesScroll = restoreDashboardContentScroll;
